var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    preserveAspectRatio: "xMidYMid",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 256 V 256 H 0 Z",
    fill: "#f7df1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 67.311746,213.93229 19.590908,-11.85605 c 3.779454,6.70111 7.217575,12.3709 15.464436,12.3709 7.90511,0 12.88899,-3.09232 12.88899,-15.12026 v -81.79809 h 24.05749 V 199.667 c 0,24.91733 -14.60581,36.25894 -35.91517,36.25894 -19.245105,0 -30.416457,-9.96734 -36.08706,-21.99568",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.38095,211.35441 19.58847,-11.34161 c 5.15657,8.42118 11.85849,14.60703 23.71495,14.60703 9.96815,0 16.32467,-4.98387 16.32467,-11.85767 0,-8.24848 -6.52962,-11.17014 -17.52787,-15.98009 l -6.01275,-2.57951 c -17.35721,-7.38783 -28.87111,-16.66722 -28.87111,-36.25772 0,-18.04353 13.7472,-31.79154 35.22844,-31.79154 15.29417,0 26.29201,5.32764 34.19591,19.24713 l -18.73107,12.02834 c -4.12444,-7.38864 -8.59103,-10.30948 -15.46443,-10.30948 -7.04569,0 -11.51391,4.46781 -11.51391,10.30948 0,7.21758 4.46822,10.13964 14.77771,14.60785 l 6.01396,2.57747 c 20.44953,8.76455 31.96343,17.69936 31.96343,37.8043 0,21.65353 -17.01221,33.50958 -39.86692,33.50958 -22.33945,0 -36.7746,-10.65366 -43.81907,-24.57356",
    fill: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.22804f5ecc1335b9b1c5d112967ce0c5.svg";
export { ForwardRef as ReactComponent };